import {
  Table as MuiTable,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableContainer as MuiTableContainer,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
} from '@mui/material'

import { TableCell } from '~/features/guild/components/table/cells'
import { HeaderRow } from '~/features/guild/components/table/rows'
import type { TableColumn, TableProps, TableRow } from '~/features/guild/components/table/types'
import { keyOfRow } from '~/features/guild/components/table/utils'

/**
 * 构建固定列的表格
 * @param props 表格组件参数
 * @returns 固定的列组件
 */
export const PinnedTable = <T extends TableRow<T, Props>, Props = {}>(props: {
  /** Table 组件的参数 */
  componentProps: TableProps<T, Props>
  /** 行数据 */
  dataRows: T[]
  /** 固定的列配置 */
  pinnedColumns: TableColumn<T, Props>[]
  /** 固定的列的列宽 */
  pinnedWidth?: number
  /** 是否有筛选器行 */
  hasFilters?: boolean
}) => (
  // 配置固定的列的列宽
  <MuiTableContainer sx={{ width: props.pinnedWidth ? `${props.pinnedWidth}px` : undefined, height: '100%' }}>
    {/* 配置底色 */}
    <MuiTable sx={{ background: '#f3f3f3' }}>
      <MuiTableHead>
        <HeaderRow
          columns={props.pinnedColumns}
          headerHeight={props.componentProps.headerHeight}
          tableProps={props.componentProps.tableProps}
          includePinned
        />
      </MuiTableHead>
      <MuiTableBody>
        <MuiTableRow>
          {props.hasFilters && (
            <MuiTableCell
              key={`empty-row-pinned`}
              height={props.componentProps.filterHeight}
              sx={props.componentProps.filterCellSx}
            />
          )}
        </MuiTableRow>
        {props.dataRows?.map((item, index) => (
          <MuiTableRow key={keyOfRow(item, index, props.componentProps.tableProps)}>
            {props.pinnedColumns?.map((column) => (
              <TableCell key={column.field.toString()} column={column} row={item} />
            ))}
          </MuiTableRow>
        ))}
      </MuiTableBody>
    </MuiTable>
  </MuiTableContainer>
)
